import { ResourceItemHtmlProvider } from "./resource-item-html-provider.js";

export class ResourceItemHtmlProviderProgressDciList extends ResourceItemHtmlProvider {
    constructor(filterServices) {
        super(filterServices);
    }

    getItemHtml(item, relatedMedia) {
        let html = '';

        if (item && item.length){
            html = '<div class="col-8 -m-full -m-mb0">';

            for(let group of item){
                html += `<div class="Expandable Expandable-Mobile -m-mb1">
                            <a class="Expandable-button -m-mb0" href="#${group.urlName}">${this.encodeHtml(group.title)}</a>
                            <ul class="List0 Expandable-content -mb7 -m-mb1">`;

                for(let connector of group.items){
                    html += `<li class="-fs0 -mb1">
                                <div class="-dib -fourth -vam -l-third -m-fifth -s-fourth -tac">
                                    <img class="-w6 -s-w8 -s-pr1" src="${connector.Logo[0].Url}" alt="${this.encodeHtml(connector.Title)} logo" title="${this.encodeHtml(connector.Title)}"/>
                                </div>
                                <div class="-dib -three-fourths -vam -l-two-thirds -m-four-fifths -s-three-fourths">
                                    <a class="-fs18 -c-link -h-c-link" href="/connectors/${connector.UrlName}">${this.encodeHtml(connector.Title)}</a>
                                </div>
                            </li>`;
                }

                html += '</ul></div>';
            }

            html += '</div>';
        }

        return html;
    }
}
